import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import { Box, Button } from '@mui/material';
import { MouseEvent, ReactElement } from 'react';
import { useIntl } from 'react-intl';
import { formatTranslation } from 'intl';
import { InspectionTranslationKeys } from 'intl/keys';
import {
  notApplicableToggleIconSx,
  notApplicableToggleIdleSx,
  notApplicableToggleRootSx,
  notApplicableToggleSkippedSx,
  notApplicableToggleStaticSx,
} from './styles';

interface NotApplicableToggleProps {
  isSkipped: boolean;
  disabled?: boolean;
  onClick?: () => void;
  stopPropagation?: boolean;
  interactive?: boolean;
  dataQa?: string;
}

export function NotApplicableToggle({
  isSkipped,
  disabled = false,
  onClick,
  stopPropagation = false,
  interactive = true,
  dataQa = 'not-applicable-toggle',
}: NotApplicableToggleProps): ReactElement {
  const intl = useIntl();
  const label = formatTranslation(
    intl,
    InspectionTranslationKeys.notApplicable
  );
  const appearanceSx = [
    notApplicableToggleRootSx,
    isSkipped ? notApplicableToggleSkippedSx : notApplicableToggleIdleSx,
  ];

  if (!interactive) {
    const handleStaticClick = (event: MouseEvent<HTMLElement>): void => {
      event.stopPropagation();
      event.preventDefault();
    };

    return (
      <Box
        component='span'
        data-qa={dataQa}
        aria-disabled='true'
        onClick={handleStaticClick}
        sx={[...appearanceSx, notApplicableToggleStaticSx]}
      >
        <BlockOutlinedIcon sx={notApplicableToggleIconSx} />
        {label}
      </Box>
    );
  }

  const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
    if (stopPropagation) {
      event.stopPropagation();
    }
    if (disabled || !onClick) {
      return;
    }
    onClick();
  };

  return (
    <Button
      type='button'
      data-qa={dataQa}
      disabled={disabled}
      aria-pressed={isSkipped}
      onClick={handleClick}
      startIcon={<BlockOutlinedIcon />}
      sx={appearanceSx}
    >
      {label}
    </Button>
  );
}
